import React, { FC, useEffect, useRef } from 'react';

import {
  Button,
  ButtonIconPositionEnum,
  FormContainer,
  FormInput,
  FormSelect,
} from '@argenta/react-ui';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { t, Trans } from '@lingui/macro';

import { useToggles } from '../../hooks/useToggles';
import {
  formContainerStrings,
  vacancySectorOptions,
} from '../../pages/SearchVacancies/SearchVacancies.strings';
import { PostalCodeInput } from '../PostalCodeInput';

import {
  SearchFilterFormValues,
  VacanciesSearchFilterProps,
  VacancyFilterMode,
} from './VacanciesSearchFilter.types';

export const VacanciesSearchFilter: FC<VacanciesSearchFilterProps> = ({
  onSearch,
  showPostalCode,
  isLoading,
  filterMode,
}) => {
  const formRef = React.createRef<FormContainer<SearchFilterFormValues>>();
  const previousFilterMode = useRef(VacancyFilterMode.ALL);

  const {
    features: { HB6056_updated_sectors_new_api },
  } = useToggles();

  useEffect(() => {
    if (previousFilterMode.current !== filterMode) {
      previousFilterMode.current = filterMode;
      if (filterMode === VacancyFilterMode.HQ) {
        formRef.current?.setFieldValue('postalCode', undefined, true);
      }
      // force submit to apply all the filters
      formRef?.current?.onSubmitForm();
    }
  }, [previousFilterMode, filterMode, formRef]);

  return (
    <div className="argnt-vacancies-search-filters">
      <FormContainer<SearchFilterFormValues>
        i18nStrings={formContainerStrings}
        initialValues={{}}
        ref={formRef}
        onSubmit={onSearch}
        hideSubmitButtons
      >
        <div className="argnt-vacancies-search-filters-wrappers">
          <div className="argnt-vacancies-search--sector">
            <FormSelect
              i18nStrings={{
                placeholderText: t({ id: 'vacancies.search.placeholders.sectors' }),
                searchText: '',
                emptyText: '',
              }}
              isClearable
              name="sector"
              options={vacancySectorOptions(HB6056_updated_sectors_new_api)}
            />
          </div>
          <FormInput
            name="searchTerm"
            placeholder={t({ id: 'vacancies.search.placeholders.searchTerm' })}
            isClearable
          />
          {showPostalCode && (
            <div className="argnt-vacancies-search--postalCode">
              <PostalCodeInput name="postalCode" />
            </div>
          )}
          <Button
            type="submit"
            icon={faSearch}
            iconPosition={ButtonIconPositionEnum.LEFT}
            loading={isLoading}
          >
            <Trans id="vacancies.search.searchBtn" />
          </Button>
        </div>
      </FormContainer>
    </div>
  );
};
